import React from 'react'
import ChatNow from "../chatnow";
import Slider from "react-slick";

const Hero = () => {
    const slider1 = React.useRef(null);
    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className='' id="hero">
            <Slider {...settings} ref={slider1}>
                <div className='relative'>
                    <div className='hidden md:block max-h-screen'>
                        <img src='/assets/images/ny-road-background.jpg' alt="" />
                    </div>
                    <div className=' md:hidden block max-h-screen'>
                        <img src='/assets/images/ny-road-background-mobile.jpg' alt="" />
                    </div>

                    <div className='container mx-auto px-4 md:px-6'>
                        <div className='absolute top-1/2 transform -translate-y-1/2 z-10 lg:max-w-[75%] xl:max-w-[50%]'>
                            <h2 className='font-medium text-5xl md:text-7xl text-white'>The Road to Justice
                                Starts With A Click</h2>
                            <p className='text-white font-light mt-4'>Demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue</p>
                        </div>
                    </div>


                </div>
                <div className='relative'>
                    <div className='hidden md:block max-h-screen'>
                        <img src='/assets/images/ny-road-background.jpg' alt="" />
                    </div>
                    <div className=' md:hidden block max-h-screen'>
                        <img src='/assets/images/ny-road-background-mobile.jpg' alt="" />
                    </div>

                    <div className='container mx-auto px-4 md:px-6'>
                        <div className='absolute top-1/2 transform -translate-y-1/2 z-10 lg:max-w-[75%] xl:max-w-[50%]'>
                            <h2 className='font-medium text-5xl md:text-7xl text-white'>The Road to Justice
                                Starts With A Click</h2>
                            <p className='text-white font-light mt-4'>Demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue</p>
                        </div>
                    </div>
                </div>

                <div className='relative'>
                    <div className='hidden md:block max-h-screen'>
                        <img src='/assets/images/ny-road-background.jpg' alt="" />
                    </div>
                    <div className=' md:hidden block max-h-screen'>
                        <img src='/assets/images/ny-road-background-mobile.jpg' alt="" />
                    </div>

                    <div className='container mx-auto px-4 md:px-6'>
                        <div className='absolute top-1/2 transform -translate-y-1/2 z-10 lg:max-w-[75%] xl:max-w-[50%]'>
                            <h2 className='font-medium text-5xl md:text-7xl text-white'>The Road to Justice
                                Starts With A Click</h2>
                            <p className='text-white font-light mt-4'>Demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue</p>
                        </div>
                    </div>


                </div>
            </Slider>

            <div className='absolute max-sm:left-0 right-0 bottom-24 sm:bottom-14 sm:right-14 p-4'>
                <ChatNow text="Chat with a lawyer right now!" />
            </div>
        </div>
    )
}

export default Hero